import { render, staticRenderFns } from "./staticPage.vue?vue&type=template&id=51bd01b2&scoped=true&"
import script from "./staticPage.vue?vue&type=script&lang=js&"
export * from "./staticPage.vue?vue&type=script&lang=js&"
import style0 from "./staticPage.vue?vue&type=style&index=0&id=51bd01b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bd01b2",
  null
  
)

export default component.exports